import axios from 'axios'
import { ApiResult } from './models'

export async function request(url = '', option = {}): Promise<ApiResult> {
  return new Promise((resolve, reject) => {
    axios({
      url: url,
      ...option
    }).then(function (res) {
      resolve(res.data as ApiResult)
    }).catch(function (error) {
      console.log(error,'????');
      if (error.request && error.request.response) {
        let result: ApiResult = {
          code: 500,
          msg: '请求失败',
          issucess: false,
          result: null,
          data: null
        }
        try {
          const jsonResponse = JSON.parse(error.request.response)
          result = jsonResponse;
        } catch (error) {

        }
        resolve(result)
      } else {
        resolve({
          code: 500,
          msg: '请求失败',
          issucess: false,
          result: null,
          data: null
        } as ApiResult)
      }

    })
  })
}

export async function downloadRequest(url = '', option = {}, fileName = '') {
  axios({
    url: url,
    ...option
  }).then(function (res) {
    const blob = new Blob([res.data], { type: 'application/xlsx' }) //创建一个类文件对象：Blob对象表示一个不可变的、原始数据的类文件对象
    const url = window.URL.createObjectURL(blob)//URL.createObjectURL(object)表示生成一个File对象或Blob对象
    let dom = document.createElement('a')//设置一个隐藏的a标签，href为输出流，设置download
    dom.style.display = 'none'
    dom.href = url
    dom.setAttribute('download', fileName)//指示浏览器下载url,而不是导航到它；因此将提示用户将其保存为本地文件
    document.body.appendChild(dom)
    dom.click()
  })
}

export async function downloadEasyExcel(url = '', data) {
  axios({
    method: 'post',// 设置请求方式
    url: url,// 设置请求地址
    data: data,
    responseType: 'blob'
  }).then(function (res) {
    // 得到请求到的数据后，对数据进行处理
    let blob = new Blob([res.data], { type: 'application/vnd.ms-excel;charset=utf-8' });// 创建一个类文件对象：Blob对象表示一个不可变的、原始数据的类文件对象
    let fileName = decodeURI(res.headers['content-disposition']);// 设置文件名称,decodeURI：可以对后端使用encodeURI() 函数编码过的 URI 进行解码。encodeURI() 是后端为了解决中文乱码问题
    // console.log(fileName)
    if (fileName) {// 根据后端返回的数据处理文件名称
      fileName = fileName.substring(fileName.indexOf('=') + 1);
    }
    const link = document.createElement('a')// 创建一个a标签
    link.download = fileName;// 设置a标签的下载属性
    link.style.display = 'none';// 将a标签设置为隐藏
    link.href = URL.createObjectURL(blob);// 把之前处理好的地址赋给a标签的href
    document.body.appendChild(link);// 将a标签添加到body中
    link.click();// 执行a标签的点击方法
    URL.revokeObjectURL(link.href) // 下载完成释放URL 对象
    document.body.removeChild(link)// 移除a标签
  })
}
export async function downloadEasyWord(url = '', data) {
  axios({
    method: 'post',// 设置请求方式
    url: url,// 设置请求地址
    data: data,
    responseType: 'blob'
  }).then(function (res) {
    // 得到请求到的数据后，对数据进行处理
    let blob = new Blob([res.data], { type: 'application/vnd.openxmlformats-officedocument.wordprocessingml.document;charset=utf-8' });// 创建一个类文件对象：Blob对象表示一个不可变的、原始数据的类文件对象
    let fileName = decodeURI(res.headers['content-disposition']);// 设置文件名称,decodeURI：可以对后端使用encodeURI() 函数编码过的 URI 进行解码。encodeURI() 是后端为了解决中文乱码问题
    // console.log(fileName)
    if (fileName) {// 根据后端返回的数据处理文件名称
      fileName = fileName.substring(fileName.indexOf('=') + 1);
    }
    const link = document.createElement('a')// 创建一个a标签
    link.download = fileName;// 设置a标签的下载属性
    link.style.display = 'none';// 将a标签设置为隐藏
    link.href = URL.createObjectURL(blob);// 把之前处理好的地址赋给a标签的href
    document.body.appendChild(link);// 将a标签添加到body中
    link.click();// 执行a标签的点击方法
    URL.revokeObjectURL(link.href) // 下载完成释放URL 对象
    document.body.removeChild(link)// 移除a标签
  })
}